module.exports = __webpack_public_path__ + "static/media/dropdown_icon.45cb039c.svg";